export default {
	// Config
	apiKey: "AIzaSyBKmui1wY3daUbO9d1GVTmwaByK7Tu3lFQ",
  authDomain: "indulgedistribution-mytrace.firebaseapp.com",
  projectId: "indulgedistribution-mytrace",
  storageBucket: "indulgedistribution-mytrace.firebasestorage.app",
  messagingSenderId: "527410794304",
  appId: "1:527410794304:web:86d30553262ee8832db4a5"
};
